import module from 'empresa/module.js'

export const schema = {
  facturacion: {
    proveedor_id: 'number',
    saldo_isr: 'number',
    saldo_iva: 'number',
    aplica_conceptocontable: 'boolean',
  },
  direcciones: {
    indice: 'number',
    empresa_id: 'number',
    matriz: 'boolean',
    codigo_postal: 'number',
    numero_exterior: 'number',
    numero_interior: 'number',
  },
}

export default class EmpresaConfiguracionFacturacionService {
  constructor ($http) {
    this.$http = $http
  }

  get (empresaId) {
    return this.$http.get('/api/empresa/configuracion/facturacion', {
      params: {
        empresa_id: empresaId,
      },
      schema,
    })
  }

  put (empresaId, data) {
    return this.$http.put('/api/empresa/configuracion/facturacion', data, {
      params: {
        empresa_id: empresaId,
      },
      schema,
    })
  }
}

module.service('EmpresaConfiguracionFacturacion', EmpresaConfiguracionFacturacionService)



// WEBPACK FOOTER //
// ./src/empresa/services/Empresa/Configuracion/Facturacion.js